/* BEGIN TFX_CART_PAGE_GUARD
   Objectif: désactiver l'usage de la page /cart et forcer un parcours drawer-only.
   Portée: toutes les pages storefront (hors Theme Editor redirect).
   Dépendances: Symmetry cart drawer + event dispatch:cart-drawer:open.
   Date: 2026-02-09
   Rollback: supprimer ce fichier + retirer son include dans layout/theme.liquid.
*/
(function () {
  'use strict';

  var FLAG = 'tfx_open_cart_drawer_after_redirect';
  function normalizePath(path) {
    return (path || '').replace(/\/+$/, '') || '/';
  }

  function isCartPath(path) {
    return /(^|\/)cart$/.test(normalizePath(path));
  }

  function isCartTemplate() {
    return !!(document.body && document.body.classList.contains('template-cart'));
  }

  function keepCartPageRequested() {
    return window.location.search.indexOf('tfx_keep_cart_page=1') !== -1;
  }

  function hasQueryParamsBesidesKeepFlag() {
    if (!window.location.search || window.location.search.length <= 1) return false;

    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('tfx_keep_cart_page');
      return Array.from(params.keys()).length > 0;
    } catch (e) {
      return true;
    }
  }

  function hasDrawerMode() {
    return !!(window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer');
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getSafeRedirectUrl() {
    var fallback = window.location.origin + '/';

    try {
      if (!document.referrer) return fallback;
      var ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return fallback;
      if (isCartPath(ref.pathname)) return fallback;
      return ref.href;
    } catch (e) {
      return fallback;
    }
  }

  function openDrawerWhenReady() {
    if (openDrawerWhenReady._opened) return;

    var attempts = 0;
    var maxAttempts = 40;

    function tryOpen() {
      var drawer = document.querySelector('.js-cart-drawer');
      if (drawer) {
        openDrawerWhenReady._opened = true;
        document.removeEventListener('shopify:section:load', openDrawerWhenReady);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        window.requestAnimationFrame(tryOpen);
      } else if (openDrawerWhenReady._listening) {
        document.removeEventListener('shopify:section:load', openDrawerWhenReady);
        openDrawerWhenReady._listening = false;
      }
    }

    window.requestAnimationFrame(tryOpen);
  }

  if (!hasDrawerMode()) return;

  if (isCartTemplate() && !isDesignMode() && !keepCartPageRequested() && !hasQueryParamsBesidesKeepFlag()) {
    try {
      sessionStorage.setItem(FLAG, '1');
    } catch (e) {}

    window.location.replace(getSafeRedirectUrl());
    return;
  }

  var shouldOpen = false;
  try {
    shouldOpen = sessionStorage.getItem(FLAG) === '1';
    if (shouldOpen) sessionStorage.removeItem(FLAG);
  } catch (e) {}

  if (!shouldOpen) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openDrawerWhenReady, { once: true });
  } else {
    openDrawerWhenReady();
  }

  if (!openDrawerWhenReady._listening) {
    document.addEventListener('shopify:section:load', openDrawerWhenReady);
    openDrawerWhenReady._listening = true;
  }
})();
/* END TFX_CART_PAGE_GUARD */
